export const MENU_DRAWER_WIDTH = 290
export const MINI_MENU_DRAWER_WIDTH = 72
export const DISCRETE_COLOR_RANGE = [
  '#12939A',
  '#79C7E3',
  '#1A3177',
  '#FF9833',
  '#EF5D28'
]

export const EXTENDED_DISCRETE_COLOR_RANGE = [
  '#19CDD7',
  '#DDB27C',
  '#88572C',
  '#FF991F',
  '#F15C17',
  '#223F9A',
  '#DA70BF',
  '#125C77',
  '#4DC19C',
  '#776E57',
  '#12939A',
  '#17B8BE',
  '#F6D18A',
  '#B7885E',
  '#FFCB99',
  '#F89570',
  '#829AE3',
  '#E79FD5',
  '#1E96BE',
  '#89DAC1',
  '#B3AD9E'
]

export const CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833']



// WEBPACK FOOTER //
// ./src/constants/styles.js